import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './SelectPayment.module.scss';
import { Modal } from "../../../../components";
import Transfer from "../payment-types/Transfer";
import BankKhiku from "../payment-types/BankKhiku";
import BillDetail from "../bill-info/bill-detail/BillDetail";
import BillInfoForm from "../bill-info-form/BillInfoForm";
import { emptyFn } from "../../../../shared";
import clsx from 'clsx';
import WebPay from "../payment-types/WebPay";
import { registerAnalyticsEvent } from 'shared/utils/analytics';
import { Google_Analitys_Categories } from 'settings/data';

export const SelectPayment = props => {
  const modalRef = React.useRef();
  const { billInfo, onEditBillInfo, onRemoveBillInfo, onEditPaymentType, paymentType } = props;
  const showBillDetail = billInfo && billInfo.rut;
  const { cat_new_report, ga_actions } = Google_Analitys_Categories;

  const openModal = useCallback(() => {
    modalRef.current.open();
  }, []);

  const closeModal = useCallback(() => {
    modalRef.current.close();
  }, []);

  const setBillInfo = (formData) => {
    closeModal();
    if (onEditBillInfo) {
      onEditBillInfo(formData);
    }
  };

  const onUpdatePaymentType = (event) => {
    if (onEditPaymentType) {
      onEditPaymentType(event.currentTarget.value);
    }
  };

  useEffect(() => {
    registerAnalyticsEvent({ category: cat_new_report, action: ga_actions.load, label: 'init_payment_method_step' });
  }, [])

  return (
      <div className="d-flex flex-column flex-fill">
        {
          showBillDetail
              ? <BillDetail onEdit={openModal} billInfo={billInfo} onRemove={onRemoveBillInfo} />
              :
              <span className={clsx(styles.billMessage, "pt-sm mx-sm")} onClick={openModal}>¿Deseas recibir factura?</span>
        }

        <WebPay onChange={onUpdatePaymentType} paymentType={paymentType} />
        <Transfer onChange={onUpdatePaymentType} paymentType={paymentType} />
        <BankKhiku onChange={onUpdatePaymentType} paymentType={paymentType} />

        <Modal ref={modalRef} title="Datos de Facturación">
          <BillInfoForm onCancelAction={closeModal} onSubmitAction={setBillInfo} billInfo={billInfo} />
        </Modal>
      </div>
  );
};

SelectPayment.propTypes = {
  onEditPaymentType: PropTypes.func,
  onEditBillInfo: PropTypes.func,
  onRemoveBillInfo: PropTypes.func,
  billInfo: PropTypes.object,
  paymentType: PropTypes.string
};

SelectPayment.defaultProps = {
  onRemoveBillInfo: emptyFn(),
  billInfo: {}
};

export default SelectPayment;
